import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  FormArray
} from '@angular/forms';
import { Router } from '@angular/router';
import { RegistrationService } from '../../services/registration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/components/common/messageservice';

@Component({
  selector: 'app-additional-information',
  templateUrl: './additional-information.component.html',
  styleUrls: ['./additional-information.component.scss'],
  providers: [MessageService]
})
export class AdditionalInformationComponent implements OnInit {
  msgs: Message[] = [];
  activeIndex = 3;
  alertMsg: Message[] = [];

  public additionalForm: any;

  public bloodgrpList = [];
  public nationalityList = [];
  public boardList = [];
  public religionList = [];
  public genericList = [];
  public phList = [];
  public maleTitleList = [];
  public femaleTitleList = [];
  public familyIncomeList = [];
  public admsportsList = [];
  public awardlevelList = [];
  public parentstaffdeptList = [];

  public familyalumnirelationList = [];
  public familyalumnibatchList = [];
  public familyalumnicourseList = [];

  dataList: any;
  sportsEntry = false;
  isFather = false;
  isMother = false;
  ismlabel = true;
  isflabel = true;
  enablePhType: boolean = true;
  showclose = false;
  disablesubmit = false;
  input = new FormData();
  uploadedFiles: any[] = [];
  enableParentstaff: boolean = true;
  enableFamilyAlumni: boolean = true;
  shwchat = false;
  disableaddrow = false;

  alphaOnlyRegEx = "^[a-zA-Z ]*$";
  numOnlyRegEx = "^[0-9]*$";
  dsingleParent: boolean = false;

  constructor(
    private registrationService: RegistrationService,
    private fb: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private messageService: MessageService
  ) { }
  private token = JSON.parse(localStorage.getItem('userDetails'));
  ngOnInit() {
    this.msgs = [];
    this.alertMsg = [];
    this.msgs.push({ severity: 'info', summary: 'Please Note :' });
    this.msgs.push({ severity: 'info', summary: 'i. Sr. No. 18 cannot be same as Mobile Number and Whatsapp Number given in Step 1.' });
    this.msgs.push({ severity: 'info', summary: "ii. In case of Physically challanged being 'Yes', relevant documents will be required at the time of admission, if Selected." });
    this.msgs.push({ severity: 'info', summary: 'iii. <font color="red">Red dot</font> indicates mandatory field.' });
    this.autoLogin();
    this.additionalForm = new FormGroup({
      emergencyContactNo: new FormControl('', [
        Validators.required,
        Validators.minLength(10), Validators.pattern(this.numOnlyRegEx)
      ]),
      bloodGroup: new FormControl(null, Validators.required),
      religionId: new FormControl(null, Validators.required),
      handicapped: new FormControl('No', Validators.required),
      handicaptype: new FormControl(null),
      //adhaarcardno: new FormControl(''),
      sParent: new FormControl('No', Validators.required),
      fTitle: new FormControl(null, Validators.required),
      fatherName: new FormControl('', [Validators.required, Validators.pattern(this.alphaOnlyRegEx)]),
      mTitle: new FormControl(null, Validators.required),
      motherName: new FormControl('', [Validators.required, Validators.pattern(this.alphaOnlyRegEx)]),
      familyIncome: new FormControl(null, Validators.required),
      sportsQuota: new FormControl('No', Validators.required),
      resismartphone: new FormControl('Yes', Validators.required),
      resilaptop: new FormControl('Yes', Validators.required),
      resiinternet: new FormControl('Yes', Validators.required),

      parentstaff: new FormControl('No', Validators.required),
      parentstaffname: new FormControl(''),
      parentstaffdeptid: new FormControl(null),

      // familyalumni: new FormControl(null, Validators.required),
      // familyalumniname: new FormControl(''),
      // familyalumnirelation: new FormControl(null),
      // familyalumnibatch: new FormControl(null,),
      // familyalumnicourseid: new FormControl(null),

      nccQuota: new FormControl('No', Validators.required),     //latest addition

      sportsDetails: this.fb.array([])
    });
    this.getAdditionalLists();
    this.additionalForm.get('handicaptype').disable();
    this.additionalForm.get('parentstaffname').disable();
    this.additionalForm.get('parentstaffdeptid').disable();

    // this.additionalForm.get('familyalumniname').disable();
    // this.additionalForm.get('familyalumnirelation').disable();
    // this.additionalForm.get('familyalumnibatch').disable();
    // this.additionalForm.get('familyalumnicourseid').disable();

    if (localStorage.getItem('step') == '') {
      this.showclose = true;
    }
    if (localStorage.getItem('meritlisted') === "yes") {
      this.disablesubmit = true;
    }

    if (localStorage.getItem('sports')) {
      this.disableaddrow = true;
    }
  }
  // ngAfterViewInit() {
  //   (document.querySelector('.layout-wrapper .layout-content .layout-content-container') as HTMLElement).style.marginTop = '-50px';
  // }

  // ngOnDestroy() {
  //   (document.querySelector('.layout-wrapper .layout-content .layout-content-container') as HTMLElement).style.marginTop = '10px';
  // }


  getAdditionalLists() {
    this.registrationService
      .getAdditionalList(this.token.authToken)
      .subscribe(data => {
        this.dataList = data;
        this.bloodgrpList = this.dataList.bloodgroupList;
        this.nationalityList = this.dataList.nationalityList;
        this.religionList = this.dataList.religionList;
        this.admsportsList = this.dataList.admsportsList;
        this.awardlevelList = this.dataList.awardlevelList;
        this.parentstaffdeptList = this.dataList.parentstaffdeptList;
        //this.familyalumnicourseList = this.dataList.familyalumnicourseList;

        this.genericList = [
          { id: 'No', name: 'No' },
          { id: 'Yes', name: 'Yes' }
        ];
        this.phList = [
          { id: 'Visually Handicapped', name: 'Visually Handicapped' },
          { id: 'Orthopaedically Handicapped', name: 'Orthopaedically Handicapped' },
          { id: 'Hearing Impairment', name: 'Hearing Impairment' }
        ];

        this.maleTitleList = [
          { id: 'Mr.', name: 'Mr.' },
          { id: 'Dr.', name: 'Dr.' },
          { id: 'Prof.', name: 'Prof.' },
          { id: 'Late', name: 'Late' }
        ];
        this.femaleTitleList = [
          { id: 'Mrs.', name: 'Mrs.' },
          { id: 'Dr.', name: 'Dr.' },
          { id: 'Prof.', name: 'Prof.' },
          { id: 'Late', name: 'Late' }
        ];
        this.familyIncomeList = [
          { id: 'Upto 1.2 Lakhs', name: 'Upto 1.2 Lakhs' },
          { id: '1.2 to 3 Lakhs', name: '1.2 to 3 Lakhs' },
          { id: '3 to 5 Lakhs', name: '3 to 5 Lakhs' },
          { id: '5 to 8 Lakhs', name: '5 to 8 Lakhs' },
          { id: '8 Lakhs & above', name: '8 Lakhs & above' }
        ];

        this.familyalumnirelationList = [
          { id: 'Father', name: 'Father' },
          { id: 'Mother', name: 'Mother' },
          { id: 'Brother', name: 'Brother' },
          { id: 'Sister', name: 'Sister' }
        ];

        let date = new Date;
        let currentyear = date.getFullYear();
        let startyear = 1967;
        let yearlength = currentyear - startyear;
        // alert(yearlength);

        for (let i = startyear; i < startyear + yearlength; i++) {
          //console.log(i);
          var obj = { "id": i, "name": i };
          this.familyalumnibatchList.push(obj);
        }

        this.spinner.hide();
      });
  }

  patchForm() {
    this.token = '';
    this.token = JSON.parse(localStorage.getItem('userDetails'));
    this.additionalForm.patchValue(this.token);
    this.showSportsEntryEdit();
    this.setSports();
    this.isSingleParent();
    this.enableHanidcapType();
    this.parentstaff();
    //this.familyAlumni();
    // this.singleParent();
  }

  setSports() {
    const control = <FormArray>this.additionalForm.controls.sportsDetails;
    this.token.sportsDetails.forEach(x => {
      control.push(
        this.fb.group({
          sportsid: x.sportsid,
          levelid: x.levelid,
          id: x.id,
          parent_id: x.parent_id,
          //filename:x.filename
        })
      );
    });
  }

  saveAdditionalDetails() {
    const control = this.additionalForm.value.sportsDetails;
    const sportsQuota = this.additionalForm.value.sportsQuota;
    if (sportsQuota == 'Yes' && control.length == 0) {
      alert('Please add atleast one sports details');
      return false;
    }

    for (let i = 0; i < control.length; i++) {
      // alert(control[i].sportsid);
      if (control[i].sportsid == null) {
        alert('Please select sports at row no.' + (1 + i));
        return false;
      }
      if (control[i].levelid == null) {
        alert('Please select level at row no.' + (1 + i));
        return false;
      }
      // if (control[i].levelid != 4 && control[i].filename == '') {
      //   alert('Please upload certificate at row no.' + (1 + i));
      //   return false;
      // }
    }
    //console.log(this.additionalForm.value);
    if (this.additionalForm.valid) {
      //console.log(this.additionalForm.value);
      this.spinner.show();
      this.registrationService.saveAdditionalDetailsApi(this.token.authToken, this.additionalForm.value).subscribe(data => {
        this.dataList = data;
        if (this.dataList.status === 'success') {
          this.spinner.hide();
          alert('Additional data saved');
          if (localStorage.getItem('step') !== '') {
            this.router.navigate(['admission/payment-information']);
          }
          else {
            this.router.navigate(['candidate/dashboard']);
          }
        }
      }, error => {
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });
    } else {
      console.log('Form Not Submitted!');
      //console.log(this.additionalForm);
      Object.keys(this.additionalForm.controls).forEach(ctrl => {
        this.additionalForm.controls[ctrl].markAsDirty();
      });
    }
  }
  autoLogin() {
    this.spinner.show();
    this.registrationService
      .loginByToken(localStorage.getItem('authToken'))
      .subscribe(
        data => {
          this.dataList = data;
          localStorage.setItem('authToken', this.dataList.authToken);
          localStorage.setItem(
            'userDetails',
            JSON.stringify(this.dataList.userDetails)
          );
          localStorage.setItem('step', this.dataList.step);
          if (this.dataList.userDetails.bloodGroup != null) {
            this.patchForm();
          }
        },
        err => console.log(err),
        () => console.log('Request Completed')
      );
  }

  checkContactNo() {
    if (this.additionalForm.value.emergencyContactNo === this.token.studentPersonalContactNo || this.additionalForm.value.emergencyContactNo === this.token.whatsappno) {
      alert('Alternate Mobile Number cannot be same as Login ID and WhatsApp Number.');
      this.additionalForm.controls.emergencyContactNo.setValue(null);
    }
  }

  addSports() {
    const control = <FormArray>this.additionalForm.controls['sportsDetails'];
    const newMarksGroup: FormGroup = this.initItems();
    control.push(newMarksGroup);
  }
  initItems(): FormGroup {
    return this.fb.group({
      sportsid: [null, Validators.required],
      levelid: [null, Validators.required],
      id: [''],
      //filename:[''],
      parent_id: ['0']
    });
  }

  showSportsEntry() {
    const arr = <FormArray>this.additionalForm.controls['sportsDetails'];
    if (this.additionalForm.value.sportsQuota === 'Yes') {
      this.sportsEntry = true;
      if (arr.length < 1) {
        for (let i = 1; i <= 1; i++) {
          this.addSports();
        }
      }

    } else {
      this.sportsEntry = false;
      const control = <FormArray>this.additionalForm.controls['sportsDetails'];
      for (let i = control.length; i >= 0; i--) {
        control.removeAt(i);
      }
    }
  }

  showSportsEntryEdit() {
    const arr = <FormArray>this.additionalForm.controls['sportsDetails'];
    if (this.additionalForm.value.sportsQuota === 'Yes') {
      this.sportsEntry = true;
    } else {
      this.sportsEntry = false;
      const control = <FormArray>this.additionalForm.controls['sportsDetails'];
      for (let i = control.length; i >= 0; i--) {
        control.removeAt(i);
      }
    }
  }

  removeSports(id, index) {
    const control = <FormArray>this.additionalForm.controls['sportsDetails'];
    control.removeAt(index);
    this.registrationService.deleteRowBySports(id).subscribe(data => {
      this.dataList = data;
      this.msgs.push({
        severity: 'success',
        summary: 'Success Message',
        detail: 'Selected Row Successfully Deleted'
      });
    });
  }

  singleParent() {
    if (this.additionalForm.value.sParent === 'Yes') {
      this.dsingleParent = true;
    }
    this.isMother = false;
    this.ismlabel = true;
    this.isflabel = true;
    this.isFather = false;

    this.additionalForm.controls.fatherName.setValue('');
    this.additionalForm.controls.fTitle.setValue(null);
    this.additionalForm.controls.motherName.setValue('');
    this.additionalForm.controls.mTitle.setValue(null);
  }

  isSingleParent() {
    const motherName = this.additionalForm.get('motherName');
    const mTitle = this.additionalForm.get('mTitle');
    const fatherName = this.additionalForm.get('fatherName');
    const fTitle = this.additionalForm.get('fTitle');

    if (this.additionalForm.value.sParent === 'Yes') {
      if (this.additionalForm.value.fTitle != null) {
        this.isMother = true;
        this.ismlabel = false;

        this.additionalForm.controls.motherName.setValue('');
        this.additionalForm.controls.mTitle.setValue(null);

        mTitle.clearValidators();
        motherName.clearValidators();
      }
      else if (this.additionalForm.value.fTitle === null) {
        this.ismlabel = true;
        this.isMother = false;
        mTitle.setValidators([Validators.required]);
        motherName.setValidators([Validators.required, Validators.pattern(this.alphaOnlyRegEx)]);
      }
      if (this.additionalForm.value.mTitle != null) {
        this.isFather = true;
        this.isflabel = false;
        this.additionalForm.controls.fatherName.setValue('');
        this.additionalForm.controls.fTitle.setValue(null);
        fTitle.clearValidators();
        fatherName.clearValidators();
      }
      else if (this.additionalForm.value.mTitle === null) {
        this.isFather = false;
        this.isflabel = true;
        fTitle.setValidators([Validators.required]);
        fatherName.setValidators([Validators.required, Validators.pattern(this.alphaOnlyRegEx)]);
      }
    }
    else {
      fTitle.setValidators([Validators.required]);
      fatherName.setValidators([Validators.required, Validators.pattern(this.alphaOnlyRegEx)]);
      mTitle.setValidators([Validators.required]);
      motherName.setValidators([Validators.required, Validators.pattern(this.alphaOnlyRegEx)]);
    }
    mTitle.updateValueAndValidity();
    motherName.updateValueAndValidity();
    fTitle.updateValueAndValidity();
    fatherName.updateValueAndValidity();
  }

  avoidNumber(event) {
    if (event.keyCode >= 48 && event.keyCode <= 57) return false;
  }

  enableHanidcapType() {
    const handicaptype = this.additionalForm.get('handicaptype');
    if (this.additionalForm.value.handicapped === 'Yes') {
      this.additionalForm.get('handicaptype').enable();
      handicaptype.setValidators([Validators.required]);
      this.enablePhType = false;
    } else {
      this.additionalForm.controls.handicaptype.setValue(null);
      this.additionalForm.get('handicaptype').disable();
      handicaptype.clearValidators();
      this.enablePhType = true;
    }
    handicaptype.updateValueAndValidity();
  }

  parentstaff() {
    const parentstaffname = this.additionalForm.get('parentstaffname');
    const parentstaffdeptid = this.additionalForm.get('parentstaffdeptid');
    if (this.additionalForm.value.parentstaff === 'Yes') {
      this.additionalForm.get('parentstaffname').enable();
      this.additionalForm.get('parentstaffdeptid').enable();
      parentstaffname.setValidators([Validators.required]);
      parentstaffdeptid.setValidators([Validators.required]);
      this.enableParentstaff = false;
    } else {
      this.additionalForm.controls.parentstaffname.setValue('');
      this.additionalForm.controls.parentstaffdeptid.setValue(null);
      this.additionalForm.get('parentstaffname').disable();
      this.additionalForm.get('parentstaffdeptid').disable();
      parentstaffname.clearValidators();
      parentstaffdeptid.clearValidators();
      this.enableParentstaff = true;
    }
    parentstaffname.updateValueAndValidity();
    parentstaffdeptid.updateValueAndValidity();
  }

  // familyAlumni(){
  //   const familyalumniname = this.additionalForm.get('familyalumniname');
  //   const familyalumnirelation = this.additionalForm.get('familyalumnirelation');
  //   const familyalumnibatch = this.additionalForm.get('familyalumnibatch');
  //   const familyalumnicourseid = this.additionalForm.get('familyalumnicourseid');

  // 	if (this.additionalForm.value.familyalumni === 'Yes') {
  //     this.additionalForm.get('familyalumniname').enable();
  //     this.additionalForm.get('familyalumnirelation').enable();
  //     this.additionalForm.get('familyalumnibatch').enable();
  //     this.additionalForm.get('familyalumnicourseid').enable();
  //     familyalumniname.setValidators([Validators.required]);
  //     familyalumnirelation.setValidators([Validators.required]);
  //     familyalumnibatch.setValidators([Validators.required]);
  //     familyalumnicourseid.setValidators([Validators.required]);
  //     this.enableFamilyAlumni = false;
  // 	} else {
  //     this.additionalForm.controls.familyalumniname.setValue('');
  //     this.additionalForm.controls.familyalumnirelation.setValue(null);
  //     this.additionalForm.controls.familyalumnibatch.setValue(null);
  //     this.additionalForm.controls.familyalumnicourseid.setValue(null);
  //     this.additionalForm.get('familyalumniname').disable();
  //     this.additionalForm.get('familyalumnirelation').disable();
  //     this.additionalForm.get('familyalumnibatch').disable();
  //     this.additionalForm.get('familyalumnicourseid').disable();
  //     familyalumniname.clearValidators();
  //     familyalumnirelation.clearValidators();
  //     familyalumnibatch.clearValidators();
  //     familyalumnicourseid.clearValidators();
  //     this.enableFamilyAlumni = true;
  // 	}
  //   familyalumniname.updateValueAndValidity();
  //   familyalumnirelation.updateValueAndValidity();
  //   familyalumnibatch.updateValueAndValidity();
  //   familyalumnicourseid.updateValueAndValidity();
  // }

  goToDashboard() {
    this.router.navigate(['candidate/dashboard']);
  }

  // myUploader(event, flg, index): void {
  //   console.log('My File upload', event);
  //   if (event.files.length == 0) {
  //     console.log('No file selected.');
  //     return;
  //   }
  //   const control = this.additionalForm.value.sportsDetails;
  //   const controlArray = <FormArray>this.additionalForm.get('sportsDetails');
  //   this.input = new FormData();
  //   var fileToUpload = event.files[0];
  //   this.input.append("file", fileToUpload);
  //   this.registrationService.docupload(this.input, flg, this.token.id).then(res => {
  //     this.dataList = res;
  //     // const name = this.dataList.name;
  //     // const emlbody = this.dataList.emlbody;
  //     // const emlpw = this.dataList.emlpw;
  //     // const emlsendto = this.dataList.emlsendto;
  //     // const emlsub = this.dataList.emlsub;
  //     // const emlun = this.dataList.emlun;
  //     // if (this.dataList.name != '-') {
  //     //   this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
  //     //     console.log('SMS sent successfully:', response);
  //     //     controlArray.controls[index].get('filename').setValue(this.dataList.file);
  //     //   })
  //     // } else {
  //     //   console.log(this.dataList.msg);
  //     // }

  //     // if (this.dataList.status == 'success') {
  //     //   controlArray.controls[index].get('filename').setValue(this.dataList.file);
  //     // }
  //     //console.log(res);
  //     this.alertMsg = [];
  //     this.alertMsg.push({
  //       severity: 'success',
  //       summary: this.dataList.message
  //     });
  //   })
  // }

  onUpload(event): void {
    console.log("onUpload");

    for (const file of event.files) {
      this.uploadedFiles.push(file);
    }

  }

  // jd 
  dsingleParentBtn() {
    this.dsingleParent = false;
  }

  dCancelParentBtn() {
    this.dsingleParent = false;
    this.additionalForm.controls.sParent.setValue("No");
  }

  onBeforeSend(event): void {
    console.log("onBeforeSend");
    //event.xhr.setRequestHeader('Authorization', 'Bearer ' + abp.auth.getToken());
  }
  onFloatClick() {
    window.open("https://app.botbaba.io/bot/1158ALGR6Xj/BESC%20QBOT");
    //this.shwchat= true;
  }


}



// WEBPACK FOOTER //
// ./src/app/admission/additional-information/additional-information.component.ts